<img [src]="src(image)" [srcset]="srcset(image)"  [sizes]="sizes(image, imageRatio)" [ngStyle]="imgStyle" alt=""/>
